(function(root, factory) {
  'use strict';
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.EnigmaYgoSinglesContext = api;
    if (root.document) api.boot(root);
  }
})(typeof window !== 'undefined' ? window : null, function(browser) {
  'use strict';

  var MAX_ROUTE_HANDLES = 96;
  var MAX_URL_LENGTH = 6000;
  var STORED_URL_LENGTH = 1800;
  var MAX_STORED_CONTEXTS = 24;
  var CONTEXT_TTL = 2 * 60 * 60 * 1000;
  var STORAGE_KEY = 'enigma:ygo-navigation:v1';
  var CONTEXT_PARAM = 'ygo_ctx';
  var RETURN_PARAM = 'ygo_return';
  var SEQUENCE_PARAM = 'ygo_seq';
  var CATALOG_PATH = '/collections/ygo-single-cards';
  var RETURN_PARAMS = ['ygo_name', 'ygo_text', 'ygo_set', 'ygo_rarity', 'ygo_language', 'ygo_condition', 'ygo_edition', 'ygo_stock', 'ygo_exact', 'ygo_sort', 'ygo_view', 'ygo_size', 'ygo_page', 'page', 'sort_by'];

  function validHandle(value) {
    return /^[a-z0-9](?:[a-z0-9-]{0,253}[a-z0-9])?$/.test(String(value == null ? '' : value));
  }

  function safeUrl(value, origin) {
    if (!value) return null;
    try { return new URL(String(value), origin || 'https://example.invalid'); }
    catch (error) { return null; }
  }

  function relativeUrl(url) { return url.pathname + url.search + url.hash; }

  function uniqueHandles(values) {
    var output = [];
    (Array.isArray(values) ? values : []).some(function(value) {
      if (validHandle(value) && output.indexOf(value) === -1) output.push(value);
      return output.length === MAX_ROUTE_HANDLES;
    });
    return output;
  }

  function localizedCatalogPath(routeRoot) {
    return String(routeRoot || '/').replace(/\/$/, '') + CATALOG_PATH;
  }

  function sanitizeReturnPath(value, origin, routeRoot) {
    var url = safeUrl(value, origin);
    if (!url || origin && url.origin !== origin || url.username || url.password) return null;
    var expectedPath = localizedCatalogPath(routeRoot);
    var actualPath = url.pathname.replace(/\/$/, '');
    if (actualPath !== CATALOG_PATH && actualPath !== expectedPath) return null;
    var sanitized = new URL(expectedPath, url.origin);
    url.searchParams.forEach(function(paramValue, name) {
      if (RETURN_PARAMS.indexOf(name) === -1 && name.indexOf('filter.') !== 0) return;
      if (name === 'filter.p.product_type' && String(paramValue).trim().toLowerCase() !== 'yugioh single') return;
      if (String(paramValue).trim()) sanitized.searchParams.append(name, paramValue);
    });
    if (/^#ygo-card-[a-z0-9](?:[a-z0-9-]{0,253}[a-z0-9])?$/.test(url.hash)) sanitized.hash = url.hash;
    return relativeUrl(sanitized);
  }

  function productHandleFromUrl(value, origin) {
    var url = safeUrl(value, origin);
    if (!url || origin && url.origin !== origin) return '';
    var segments = url.pathname.split('/').filter(Boolean);
    var index = segments.lastIndexOf('products');
    return index > -1 && index === segments.length - 2 && validHandle(segments[index + 1]) ? segments[index + 1] : '';
  }

  function returnPathForHandle(value, handle, origin, routeRoot) {
    var sanitized = sanitizeReturnPath(value, origin, routeRoot);
    if (!sanitized) return null;
    var url = new URL(sanitized, origin || 'https://example.invalid');
    if (validHandle(handle)) url.hash = 'ygo-card-' + handle;
    return relativeUrl(url);
  }

  function availableStorage(storage) {
    if (storage !== undefined) return storage;
    try { return browser && browser.sessionStorage; }
    catch (error) { return null; }
  }

  function readContexts(storage) {
    if (!storage) return [];
    try {
      var records = JSON.parse(storage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(records)) return [];
      return records.filter(function(record) {
        return record && typeof record.id === 'string' && record.created <= Date.now() && record.created > Date.now() - CONTEXT_TTL && typeof record.returnPath === 'string' && Array.isArray(record.sequence);
      }).slice(-MAX_STORED_CONTEXTS);
    } catch (error) { return []; }
  }

  function storeContext(storage, returnPath, sequence, origin) {
    if (!storage) return '';
    var canonical = new URL(returnPath, origin || 'https://example.invalid');
    canonical.hash = '';
    var path = relativeUrl(canonical);
    var records = readContexts(storage);
    var serializedSequence = sequence.join(',');
    var existing = records.find(function(record) { return record.returnPath === path && record.sequence.join(',') === serializedSequence; });
    if (existing) return existing.id;
    var id = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    records.push({ id: id, created: Date.now(), returnPath: path, sequence: sequence });
    try {
      storage.setItem(STORAGE_KEY, JSON.stringify(records.slice(-MAX_STORED_CONTEXTS)));
      return id;
    } catch (error) { return ''; }
  }

  // URL serialization is percent-encoded ASCII: its length is the request-target byte count.
  function fitSequence(url, sequence, handle, limit) {
    var index = sequence.indexOf(handle);
    if (index < 0) return;
    var start = index;
    var end = index + 1;
    url.searchParams.set(SEQUENCE_PARAM, handle);
    if (relativeUrl(url).length > limit) { url.searchParams.delete(SEQUENCE_PARAM); return; }
    while (start > 0 || end < sequence.length) {
      var nextStart = start > 0 ? start - 1 : start;
      var nextEnd = end < sequence.length ? end + 1 : end;
      url.searchParams.set(SEQUENCE_PARAM, sequence.slice(nextStart, nextEnd).join(','));
      if (relativeUrl(url).length > limit) {
        url.searchParams.set(SEQUENCE_PARAM, sequence.slice(start, end).join(','));
        break;
      }
      start = nextStart;
      end = nextEnd;
    }
  }

  function buildPdpUrl(productUrl, context, origin, routeRoot, storageOverride) {
    var url = safeUrl(productUrl, origin);
    var handle = productHandleFromUrl(productUrl, origin);
    if (!url || !handle) return null;
    url.searchParams.delete(RETURN_PARAM);
    url.searchParams.delete(SEQUENCE_PARAM);
    url.searchParams.delete(CONTEXT_PARAM);
    var returnPath = returnPathForHandle(context && context.returnPath, handle, origin, routeRoot);
    if (returnPath) {
      var sequence = uniqueHandles(context && context.sequence);
      var storage = availableStorage(storageOverride);
      var key = sequence.indexOf(handle) !== -1 ? storeContext(storage, returnPath, sequence, origin) : '';
      if (key) url.searchParams.set(CONTEXT_PARAM, key);
      var limit = key ? STORED_URL_LENGTH : MAX_URL_LENGTH;
      url.searchParams.set(RETURN_PARAM, returnPath);
      // Keep room for the selected card and immediate neighbors even with a long search query.
      if (relativeUrl(url).length > limit - 800) {
        url.searchParams.set(RETURN_PARAM, localizedCatalogPath(routeRoot) + '#ygo-card-' + handle);
      }
      if (relativeUrl(url).length > limit - 800) {
        var selectedVariant = url.searchParams.get('variant');
        url.search = '';
        if (/^\d+$/.test(selectedVariant || '')) url.searchParams.set('variant', selectedVariant);
        if (key) url.searchParams.set(CONTEXT_PARAM, key);
        url.searchParams.set(RETURN_PARAM, localizedCatalogPath(routeRoot) + '#ygo-card-' + handle);
      }
      fitSequence(url, sequence, handle, limit);
    }
    return relativeUrl(url);
  }

  function neighbors(sequence, currentHandle) {
    var handles = uniqueHandles(sequence);
    var index = handles.indexOf(currentHandle);
    return { previous: index > 0 ? handles[index - 1] : '', next: index > -1 && index < handles.length - 1 ? handles[index + 1] : '', index: index, sequence: handles };
  }

  function parsePdpContext(locationValue, currentHandle, origin, routeRoot, storageOverride) {
    var url = safeUrl(locationValue, origin);
    if (!url || origin && url.origin !== origin) return null;
    var key = url.searchParams.get(CONTEXT_PARAM);
    var stored = key && readContexts(availableStorage(storageOverride)).find(function(record) { return record.id === key && record.sequence.indexOf(currentHandle) !== -1; });
    var returnPath = returnPathForHandle(stored && stored.returnPath || url.searchParams.get(RETURN_PARAM), currentHandle, origin, routeRoot);
    if (!returnPath) return null;
    var state = neighbors(stored ? stored.sequence : String(url.searchParams.get(SEQUENCE_PARAM) || '').split(','), currentHandle);
    state.returnPath = returnPath;
    return state;
  }

  function buildNeighborUrl(locationValue, handle, context, origin, routeRoot, storageOverride) {
    var url = safeUrl(locationValue, origin);
    if (!url || !context || !validHandle(handle) || context.sequence.indexOf(handle) === -1 || !productHandleFromUrl(locationValue, origin)) return null;
    var segments = url.pathname.split('/').filter(Boolean);
    segments[segments.lastIndexOf('products') + 1] = handle;
    url.pathname = '/' + segments.join('/');
    url.search = '';
    url.hash = '';
    return buildPdpUrl(url.toString(), context, origin, routeRoot, storageOverride);
  }

  function setLinkState(link, href) {
    if (!link) return;
    link.hidden = !href;
    if (href) link.setAttribute('href', href);
    else link.removeAttribute('href');
  }

  function decoratePdp(marker, windowObject) {
    if (!marker) return;
    var currentHandle = marker.getAttribute('data-product-handle');
    if (!validHandle(currentHandle)) return;
    var origin = windowObject.location.origin;
    var routeRoot = windowObject.Shopify && windowObject.Shopify.routes && windowObject.Shopify.routes.root || '/';
    var context = parsePdpContext(windowObject.location.href, currentHandle, origin, routeRoot);
    var backHref = context && context.returnPath || sanitizeReturnPath(marker.getAttribute('data-canonical-catalog-url'), origin, routeRoot);
    if (!backHref) return;
    setLinkState(marker.querySelector('[data-ygo-route-back]'), backHref);
    setLinkState(marker.querySelector('[data-ygo-route-previous]'), context && context.previous ? buildNeighborUrl(windowObject.location.href, context.previous, context, origin, routeRoot) : null);
    setLinkState(marker.querySelector('[data-ygo-route-next]'), context && context.next ? buildNeighborUrl(windowObject.location.href, context.next, context, origin, routeRoot) : null);
    Array.prototype.forEach.call(windowObject.document.querySelectorAll('.product-single__direction'), function(legacy) {
      legacy.hidden = true;
      legacy.setAttribute('aria-hidden', 'true');
      legacy.setAttribute('data-ygo-legacy-nav-disabled', 'true');
    });
    var nav = marker.querySelector('[data-ygo-pdp-nav]');
    if (nav) nav.hidden = false;
  }

  function boot(windowObject) {
    if (!windowObject || !windowObject.document || windowObject.__enigmaYgoSinglesContextReady) return;
    windowObject.__enigmaYgoSinglesContextReady = true;
    function refresh() { decoratePdp(windowObject.document.querySelector('[data-ygo-singles-pdp-context]'), windowObject); }
    if (windowObject.document.readyState === 'loading') windowObject.document.addEventListener('DOMContentLoaded', refresh, { once: true });
    else refresh();
    windowObject.document.addEventListener('shopify:section:load', refresh);
    if (windowObject.addEventListener) windowObject.addEventListener('popstate', refresh);
  }

  return { MAX_ROUTE_HANDLES: MAX_ROUTE_HANDLES, MAX_URL_LENGTH: MAX_URL_LENGTH, MAX_STORED_CONTEXTS: MAX_STORED_CONTEXTS, STORAGE_KEY: STORAGE_KEY, validHandle: validHandle, uniqueHandles: uniqueHandles, sanitizeReturnPath: sanitizeReturnPath, productHandleFromUrl: productHandleFromUrl, buildPdpUrl: buildPdpUrl, neighbors: neighbors, parsePdpContext: parsePdpContext, buildNeighborUrl: buildNeighborUrl, decoratePdp: decoratePdp, boot: boot };
});
